
























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchComposeBeiyun extends Vue {
  @Prop()
  private message: any;
}
